import { render, staticRenderFns } from "./legal-row.vue?vue&type=template&id=f429a2de"
import script from "./legal-row.vue?vue&type=script&lang=js"
export * from "./legal-row.vue?vue&type=script&lang=js"
import style0 from "./legal-row.vue?vue&type=style&index=0&id=f429a2de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports